import { observer } from 'mobx-react-lite';
import { FC, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '~/routes/routes';
import { BackBtn } from '~/views/atoms/back.btn';
import { Support } from '~/views/organisms/support';
import { SupportMenu } from '~/views/molecules/support.menu';
import { SupportMenuItem } from '~/views/enums';
import { SupportMessages } from '~/views/organisms/support.messages';

export const PageSupport: FC = observer(() => {
    const location = useLocation();
    const isSupportPage = useMemo(() => location.pathname === ROUTES.SUPPORT.path, [location.pathname]);

    return (
        <div className="container">
            <BackBtn path={ROUTES.MAIN.path} />
            <div className="account-wrap">
                <SupportMenu activeItem={isSupportPage ? SupportMenuItem.support : SupportMenuItem.messages} />
                {isSupportPage ? <Support /> : <SupportMessages />}
            </div>
        </div>
    );
});
